// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"product-single-component_uk-open__aKgv2","grecaptcha-badge":"product-single-component_grecaptcha-badge__xrfWQ","header":"product-single-component_header__leClm","details":"product-single-component_details__wLvbv","image":"product-single-component_image__lgUxt","compare":"product-single-component_compare__yD9a9","list":"product-single-component_list__Op0us"};
    if(module.hot) {
      // 1750748407922
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  